<template>
  <div>
    <div class="columns">
      <div class="column is-10-fullhd is-offset-1-fullhd">
        <h1 class="title">Statische Seiten</h1>
        <div class="columns">
          <div class="column is-2-widescreen  is-3-tablet">
            <aside class="menu">
              <p class="menu-label menu-label--pages">
                <span>Seitenliste</span>
                <b-button
                  @click="newPage"
                  type="is-dark"
                  size="is-small"
                  icon-left="plus"
                  >Neu</b-button
                >
              </p>
              <ul class="menu-list menu-list--pages">
                <li
                  v-for="page in pages"
                  :key="page.name + page.locale"
                  class="menu-list__item"
                >
                  <a @click="loadPage(page)" class="is-block box">
                    <strong
                      >{{ page.name }}
                      <small class="has-text-grey"
                        >[{{ page.locale }}]</small
                      ></strong
                    ><br />
                    <span class="is-size-7">{{ page.title }} </span>
                  </a>
                </li>
              </ul>
            </aside>
          </div>
          <div class="column">
            <b-notification
              v-if="!page"
              type="is-info"
              :closable="false"
              class="menu-notification"
            >
              <h2 class="title is-size-4 has-text-centered">
                <b-icon
                  pack="fas"
                  icon="info-circle"
                  size="is-large"
                  class="menu-notification__icon"
                >
                </b-icon
                ><br />
                Keine Seite ausgewählt!
              </h2>
            </b-notification>

            <ValidationObserver v-slot="{invalid}">
              <div v-if="page">
                <div class="box">
                  <h2 class="title is-size-4">Seite</h2>

                  <div class="columns">
                    <div class="column is-8-tablet is-5-widescreen is-3-fullhd">
                      <ValidationProvider
                        rules="required|filename"
                        v-slot="{errors}"
                        slim
                      >
                        <b-field label="Name" :message="errors">
                          <b-input
                            v-model="page.name"
                            :disabled="!page.transient || page.localizing"
                            required
                          ></b-input>
                        </b-field>
                      </ValidationProvider>
                    </div>
                    <div class="column  is-4-tablet">
                      <ValidationProvider
                        rules="required"
                        v-slot="{errors}"
                        slim
                      >
                        <b-field label="Sprache" :message="errors">
                          <b-select
                            placeholder="Sprache"
                            v-model="page.locale"
                            :disabled="!page.transient"
                            required
                          >
                            <option value="de">Deutsch</option>
                            <option value="en">Englisch</option>
                            <option value="it">Italienisch</option>
                          </b-select>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div v-if="page && !page.transient">
                    <b-button
                      :disabled="invalid"
                      @click="newTranslation(page)"
                      type="is-info"
                      icon-left="plus"
                      >Neue Übersetzung</b-button
                    >
                  </div>
                </div>
                <div class="box">
                  <section v-if="frontmatter">
                    <h2 class="title is-size-4">Inhalt</h2>
                    <h3 class="subtitle is-size-6">(Frontmatter)</h3>

                    <div class="columns">
                      <div class="column is-4-widescreen is-3-fullhd">
                        <b-field label="Titel">
                          <b-input v-model="frontmatter.title"></b-input>
                        </b-field>
                      </div>
                      <div class="column is-8-widescreen is-9-fullhd">
                        <b-field label="Beschreibung">
                          <b-input v-model="frontmatter.description"></b-input>
                        </b-field>
                      </div>
                    </div>

                    <ValidationProvider
                      rules="required|filename"
                      v-slot="{errors}"
                      slim
                    >
                      <b-field label="Url" :message="errors" class="u-mb1">
                        <b-input v-model="frontmatter.slug" required></b-input>
                      </b-field>
                    </ValidationProvider>

                    <!-- <strong>Datenschutzerklärung:</strong>
                    {{ frontmatter.privacypolicy }} -->
                  </section>

                  <b-field label="Editor">
                    <editor v-show="content" ref="toastuiEditor" />
                  </b-field>
                </div>
                <div class="is-clearfix u-mt2 button-save-wrapper">
                  <b-button
                    :disabled="invalid"
                    @click="save()"
                    type="is-success is-pulled-right"
                    class="button--save"
                    size="is-medium"
                    >Änderungen speichern</b-button
                  >
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cmsApi from '@/api/cms-api'
import {mapGetters} from 'vuex'
import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'
import * as matter from 'gray-matter'
import {Editor} from '@toast-ui/vue-editor'
export default {
  name: 'Pages',
  components: {Editor},
  computed: {
    ...mapGetters({
      userName: 'userName',
    }),
  },
  data() {
    return {
      pages: [],
      page: null,
      content: null,
      frontmatter: null,
    }
  },
  methods: {
    newPage() {
      this.page = {
        name: 'name',
        locale: 'de',
        transient: true,
        localizing: false,
      }
      this.frontmatter = {
        title: 'Titel',
        description: 'Beschreibung',
        slug: 'page',
      }
      this.content = '# Neue Seite'
      this.$refs.toastuiEditor.invoke('setMarkdown', this.content, false)
    },
    newTranslation(page) {
      this.page = {
        name: page.name,
        locale: 'en',
        transient: true,
        localizing: true,
      }
      let res = matter(page.content)
      this.frontmatter = {
        title: this.frontmatter.title,
        description: this.frontmatter.description,
        slug: this.frontmatter.slug,
      }
      this.content = res.content
      this.$refs.toastuiEditor.invoke('setMarkdown', this.content, false)
    },
    async save() {
      if (this.page) {
        if (this.page.transient) {
          if (
            this.pages.filter(
              f =>
                f.name == this.page.name &&
                f.locale == this.page.locale &&
                !f.transient,
            ).length > 0
          ) {
            this.$buefy.toast.open({
              message: `Es gibt bereits eine Seite mit dem Name ${this.page.name}.`,
              type: 'is-danger',
            })
            return
          }
        }
        const newContent = matter.stringify(
          this.$refs.toastuiEditor.invoke('getMarkdown'),
          this.frontmatter,
        )
        const mdFile = {
          name: this.page.name,
          locale: this.page.locale,
          content: newContent,
        }
        try {
          await cmsApi.savePage(mdFile)
          if (this.page.transient) {
            this.page.transient = false
            this.pages.push({
              name: this.page.name,
              locale: this.page.locale,
            })
          }
          this.$buefy.toast.open({
            message: `Erfolgreich gespeichert.`,
            type: 'is-success',
          })
        } catch {
          this.$buefy.toast.open({
            message: `Es ist ein Fehler aufgetreten, bitte prüfen Sie Ihre Eingaben und versuchen es erneut.`,
            type: 'is-danger',
          })
        }
      }
    },
    async loadPage(selected) {
      this.page = await cmsApi.getPage(selected.locale, selected.name)
      if (this.page) {
        let res = matter(this.page.content)
        this.content = res.content
        this.frontmatter = res.data
        this.$refs.toastuiEditor.invoke('setMarkdown', res.content, false)
      }
    },
  },
  async mounted() {
    this.pages = await cmsApi.getPages()
  },
}
</script>

<style lang="scss">
.menu-label--pages {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-notification {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.menu-notification__icon {
  margin-bottom: 2rem;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .menu-list--pages {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
  }

  .menu-list__item {
    margin: 0.5rem;
  }
}

.button--save {
  width: 100%;
}

@media (min-width: 981px) {
  .button--save {
    width: auto;
  }
}

@media (max-width: 1023px) {
  .button-save-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 1rem;
    background: #fff;
    width: 100vw;
    display: flex;
    justify-content: center;
    z-index: 5;
  }
}
</style>
